import { useState, useMemo } from "react";
import { SearchCriteria } from "../types/search";

interface UseSearchReturn {
  searchCriteria: SearchCriteria;
  isSearchModalOpen: boolean;
  openSearchModal: () => void;
  closeSearchModal: () => void;
  handleSearch: (criteria: SearchCriteria) => void;
  clearAllSearch: () => void;
  hasActiveSearch: boolean;
}

export const useSearch = (): UseSearchReturn => {
  const [searchCriteria, setSearchCriteria] = useState<SearchCriteria>({
    patientFirstName: "",
    patientLastName: "",
    patientDateOfBirth: "",
  });
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  const hasActiveSearch = useMemo(() => {
    return !!(
      searchCriteria.patientFirstName.trim() ||
      searchCriteria.patientLastName.trim() ||
      searchCriteria.patientDateOfBirth.trim()
    );
  }, [searchCriteria]);

  const openSearchModal = () => {
    setIsSearchModalOpen(true);
  };

  const closeSearchModal = () => {
    setIsSearchModalOpen(false);
  };

  const handleSearch = (criteria: SearchCriteria) => {
    setSearchCriteria(criteria);
    closeSearchModal();
  };

  const clearAllSearch = () => {
    setSearchCriteria({
      patientFirstName: "",
      patientLastName: "",
      patientDateOfBirth: "",
    });
  };

  return {
    searchCriteria,
    isSearchModalOpen,
    openSearchModal,
    closeSearchModal,
    handleSearch,
    clearAllSearch,
    hasActiveSearch,
  };
};
